<template>

    <b-row>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-col size="4" v-for="(item, index) in listaRuta" :key="index">
            <b-row>
                <b-col class="mb-3">
                    <label>PTI presuntivo {{ index + 1 }}</label>
                </b-col>
            </b-row>
            <b-row v-if="item.length === 0">
                <b-col>Sin Información</b-col>
            </b-row>
            <template v-else>
                <b-row v-for="(esp, i) in item" :key="index+'esp'+i">
                    <b-col cols="12" class="mb-3">
                        <p style="font-size: 14px;">{{ esp }}</p>
                    </b-col>
                </b-row>
            </template>


        </b-col>
    </b-row>

</template>
<script>
//import draggable from "vuedraggable";
export default {
    name: "Ruta",
    props: {
        listaRuta: Array,
    },
    components: {
        //draggable
    },
    data() {
        return {
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
          dragging: false,
        };
    },
    methods: {},
    created() {
      this.debug = this.$localStorageService.getDebug();
    }
};
</script>
<style>
.Rutas {
    padding-left: 10px;
    padding-top: 20px;
}

.Titulo {
    text-align: left;
    color: rgb(47, 132, 216);
    font-weight: 600
}

.observaciones {
    width: 45%;
    padding-left: 30px;
}

.PTI {
    width: 33%;
}

.lista {
    padding-top: 5px;
    padding-bottom: 5px;
}

label {
    color: rgb(50, 50, 50) !important;
}
</style>